// extracted by mini-css-extract-plugin
export default {"tasks":"VO-z","task":"WO-z","svg":"XO-z","text":"YO-z"};